import * as React from "react";

export interface AppProps { compiler: string; framework: string; }
import titleImage from "../imgs/header_title.png"
import twitter from "../imgs/twitter.png"
import facebook from "../imgs/facebook.png"
import github from "../imgs/github.png"
import {Card} from "./Card";
import {About} from "./About"
import {Works} from "./Works";
import {Blogs} from "./Blogs";
import {Contact} from "./Contact";
import $ from 'jquery'
import {TwitterTimelineEmbed} from "react-twitter-embed"
import {Loader} from "./Loader";

export class App extends React.Component<AppProps, {}> {
    componentDidMount(): void {
        $(function() {
            var appear = false;
            var pagetop = $('#page_top');
            $(window).on('scroll', function () {
                if ($(this).scrollTop() > 100) {  //100pxスクロールしたら
                    if (appear == false) {
                        appear = true;
                        pagetop.stop().animate({
                            'right': '0px' //右から0pxの位置に
                        }, 300); //0.3秒かけて現れる
                    }
                } else {
                    if (appear) {
                        appear = false;
                        pagetop.stop().animate({
                            'right': '-200px' //右から-50pxの位置に
                        }, 300); //0.3秒かけて隠れる
                    }
                }
            });
            pagetop.on('click',function () {
                $('body, html').animate({ scrollTop: 0 }, 500); //0.5秒かけてトップへ戻る
                return false;
            });
        });
    }

    toScroll(id: String) {
        $('html,body').animate({scrollTop: $(id).offset().top }, 500, 'swing');
    }

    render() {
    return (
      <div>
          <nav className="title-panel columns">
              <div className={"fixed-top"}>
                  <a onClick={() => {this.toScroll("#about")}}>About</a> |
                  <a onClick={() => {this.toScroll("#works")}}>Works</a> |
                  <a onClick={() => {this.toScroll("#blogs")}}>Blog</a> |
                  <a onClick={() => {this.toScroll("#contact")}}>Contact</a>
              </div>
              <div className="column is-two-thirds top">
                  <Card src={titleImage} alt={"BR Branch"} width={242} height={142}/>
                  <div className={"subtitle"}>ビー・アール・ブランチ</div>
              </div>
              <div className="column right-or-center icons sns">
                  <a href={"https://twitter.com/br_branch"} target={"_blank"}><img src={twitter} alt={"Twitter"}/></a>
                  <a href={"https://www.facebook.com/kazuked"} target={"_blank"}><img src={facebook} alt={"Facebook"}/></a>
                  <a href={"https://github.com/brbranch"} target={"_blank"}><img src={github} alt={"GitHub"}/></a>
              </div>
          </nav>
          <div className="columns">
              <div className={"column is-three-quarters"}>
                  <section className={"section"} id={"about"}>
                      <About/>
                  </section>
                  <section className={"section"} id={"works"}>
                      <Works/>
                  </section>
                  <section className={"section"} id={"blogs"}>
                      <Blogs/>
                  </section>
                  <section className={"section"} id={"contact"}>
                      <Contact/>
                  </section>
              </div>
              <div className={"column subContainer"}>
                  <section className={"section"}>
                      <h2 className={"title"}>Other Links</h2>
                      <div className={"subSection panel"}>
                          <a className="panel-block is-active" href={"https://www.resume.id/branch"} target={"_blank"}>
                              <span className="panel-icon">
                                 <i className="fas fa-link" aria-hidden="true"/>
                              </span>
                              Resume(経歴書)
                          </a>
                          <a className="panel-block is-active" href={"https://crowdworks.jp/public/employees/853359"} target={"_blank"}>
                              <span className="panel-icon">
                                 <i className="fas fa-link" aria-hidden="true"/>
                              </span>
                              CloudWorks
                          </a>
                          <a className="panel-block is-active" href={"https://qiita.com/br_branch"} target={"_blank"}>
                              <span className="panel-icon">
                                 <i className="fas fa-link" aria-hidden="true"/>
                              </span>
                              Qiita
                          </a>
                          <a className="panel-block is-active" href={"https://brbranch.hatenablog.jp/"} target={"_blank"}>
                              <span className="panel-icon">
                                 <i className="fas fa-link" aria-hidden="true"/>
                              </span>
                              はてなブログ
                          </a>
                          <a className="panel-block is-active" href={"https://www.seventreasure.net/"} target={"_blank"}>
                              <span className="panel-icon">
                                 <i className="fas fa-link" aria-hidden="true"/>
                              </span>
                              七つ目の秘宝
                          </a>
                          <a className="panel-block is-active" href={"https://www.everychart.site/"} target={"_blank"}>
                              <span className="panel-icon">
                                 <i className="fas fa-link" aria-hidden="true"/>
                              </span>
                              EveryChart
                          </a>
                          <a className="panel-block is-active" href={"https://twitter.com/manmarumii"} target={"_blank"}>
                              <span className="panel-icon">
                                 <i className="fas fa-link" aria-hidden="true"/>
                              </span>
                              飼ってる猫
                          </a>
                          <a className="panel-block is-active" href={"http://brbranch.jp/blog/"} target={"_blank"}>
                              <span className="panel-icon">
                                 <i className="fas fa-link" aria-hidden="true"/>
                              </span>
                              たそがれブランチ
                          </a>
                      </div>
                  </section>
                  <section className={"section"}>
                      <h2 className={"title"}>Twitter</h2>
                      <div className={"subSection twitter"}>
                          <TwitterTimelineEmbed
                              sourceType="profile"
                              screenName="br_branch"
                              placeholder={ <Loader/> }
                          />
                      </div>
                  </section>
              </div>
          </div>
          <footer className="footer">
              <div className="content has-text-centered">
                  <p>
                      © 2020 BRBranch
                  </p>
              </div>
          </footer>
      </div>
    );
  }
}
